import axios, { type AxiosError } from "axios";
import type { DiscoAdapterSideMenuEndpointResponse } from "models/disco-adapter/EdifyChapter";
import { type ApiRequestError, RequestError } from "models/error/Error";
import cookieStorage from "persistence";
import { handlingResponse, logError } from "repositories/utils";

export const getChapterOverview = async (
  packageId: string,
  chapterId: string,
): Promise<DiscoAdapterSideMenuEndpointResponse> => {
  try {
    const result = await axios.get(
      `/api/disco/content/package/${packageId}/chapter/${chapterId}/overview`,
      {
        headers: { Authorization: cookieStorage.getToken() },
      },
    );
    return handlingResponse<DiscoAdapterSideMenuEndpointResponse>(
      [200],
      "Error getting information on chapter structure",
    )(result);
  } catch (error) {
    const { message, status } = logError(error as AxiosError<ApiRequestError>);
    throw new RequestError({
      message,
      status,
      type: "getChapterOverviewFailed",
    });
  }
};

export const getChapterExtraPractising = async (chapterId: string): Promise<unknown> => {
  try {
    const result = await axios.get(`/api/disco/content/chapter/${chapterId}/extra-practising`, {
      headers: { Authorization: cookieStorage.getToken() },
    });
    return handlingResponse<unknown>([200], "Error getting chapter extra practising")(result);
  } catch (error) {
    const { message, status } = logError(error as AxiosError<ApiRequestError>);
    throw new RequestError({
      message,
      status,
      type: "getChapterExtraPractisingFailed",
    });
  }
};

export const getSubchapterTheory = async (
  packageId: string,
  chapterId: string,
  subchapterId: string,
): Promise<unknown> => {
  try {
    const result = await axios.post(
      `/api/disco/content/package/${packageId}/chapter/${chapterId}/subchapter/${subchapterId}/theory`,
      {
        bookId: packageId,
        blocksIds: [subchapterId],
        isChapterStructure: true,
      },
      {
        headers: { Authorization: cookieStorage.getToken() },
      },
    );
    return handlingResponse<unknown>([200], "Error getting subchapter theory")(result);
  } catch (error) {
    const { message, status } = logError(error as AxiosError<ApiRequestError>);
    throw new RequestError({
      message,
      status,
      type: "getSubchapterTheoryFailed",
    });
  }
};
